import Button from '../../Button'
import styles from './ReportBlockBroken.module.scss'

export default function ReportBlockBroken({ config: { removeItem = () => {} } }) {
  return (
    <div className={styles['broken-widget']}>
      <div
        onClick={(e) => {
          e.preventDefault()
          removeItem()
        }}
      >
        <div className='border'>
          <p>Something went wrong!</p>
          <Button onClick={removeItem}>Remove</Button>
        </div>
      </div>
    </div>
  )
}

export { ReportBlockBroken }
